const goToId = () => {
    const input = document.getElementById('go-to-id');
    const label = document.querySelector('.Go-to-id__label');
    const button = document.querySelector('.Go-to-id__btn');
    const errorSpan = document.querySelector('.Go-to-id__error');

    // Функция для проверки состояния input и добавления/удаления класса
    const checkInputState = () => {
        if (input.value.trim() !== '') {
            label.classList.add('--is-minified');
        } else {
            label.classList.remove('--is-minified');
        }
    };

    // Функция для обработки перехода по ID
    const handleGoToId = async () => {
        const productId = input.value.trim();
        if (productId === '') return;

        try {
            const response = await fetch(`/index.php?route=product/product&product_id=${productId}`);
            if (response.status !== 200) {
                errorSpan.textContent = 'товар не найден';
            } else {
                window.location.href = `/index.php?route=product/product&product_id=${productId}`;
            }
        } catch (error) {
            errorSpan.textContent = 'ошибка запроса';
        }
    };

    // Отслеживание ввода в поле
    input.addEventListener('input', checkInputState);

    // Отслеживание нажатия Enter в поле ввода
    input.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
            handleGoToId();
        }
    });

    // Отслеживание клика по кнопке
    button.addEventListener('click', handleGoToId);
};

// Экспорт функции
export default goToId;
